// import React from "react";
// import Select from "react-select";

// interface OptionType {
//   id: string | number;
//   label: string;
// }

// interface RouteDropdownProps {
//   options: OptionType[];
//   value?: string | number | (string | number)[]; // Updated to support both single and multi
//   onChange: (value: string | number | (string | number)[]) => void;
//   placeholder?: string;
//   isDisabled?: boolean;
//   DropdownHeading?: string;
//   sideDropdownHeading?: string;
//   isMulti?: boolean; // New prop for multi-select mode
//   badgeBackgroundColor?: string;
//    onInputChange?: (inputValue: string) => void;
//    onMenuScrollToBottom?: () => void;
// }

// const RouteDropdown: React.FC<RouteDropdownProps> = ({
//   options,
//   value,
//   onChange,
//   placeholder = "Select an option...",
//   isDisabled = false,
//   DropdownHeading = "",
//   sideDropdownHeading = "",
//   isMulti = false, // Default is false for single-select mode
//   badgeBackgroundColor = "#43B9B2",
//   onInputChange,
//   onMenuScrollToBottom
// }) => {

//   const formattedOptions = options?.map((option) => ({
//     value: option.id.toString(),
//     label: option.label,
//   }));

//   const selectedValue = isMulti
//     ? formattedOptions.filter((option) =>
//         Array.isArray(value)
//           ? value.includes(option.value)
//           : option.value === value?.toString()
//       )
//     : formattedOptions.find((option) => option.value == value?.toString());

//   return (
//     <div style={{ width: "100%" }}>
//       {DropdownHeading && (
//         <label
//           style={{
//             fontWeight: "500",
//             marginBottom: "6px",
//             display: "block",
//             marginTop: "10px",
//           }}
//         >
//           {DropdownHeading}
//         </label>
//       )}
//       <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
//         {sideDropdownHeading && (
//           <p
//             style={{
//               display: "flex",
//               alignItems: "center",
//               color: "#2e8dd3",
//               marginRight: "5px",
//               fontWeight: "500",
//               marginLeft: "5px",
//               justifyContent: "center",
//               width: "100%",
//             }}
//           >
//             {sideDropdownHeading}
//           </p>
//         )}
//         <div style={{ width: "100%" }}>
//           <Select
//             options={formattedOptions}
//             value={selectedValue || null}
//             onChange={(selectedOption: any) => {
//               if (isMulti) {
//                 const selectedValues = selectedOption.map(
//                   (option: any) => option.value
//                 ); // Extract IDs only
//                 onChange(selectedValues);
//               } else {
//                 onChange(selectedOption?.value);
//               }
//             }}

//             onInputChange={(inputValue) => {
//              if (typeof onInputChange === "function") {
//              onInputChange(inputValue); // 👈 This will fire on each keystroke
//              }
//              }}

//             placeholder={placeholder}
//             isDisabled={isDisabled}
//             isSearchable={true}
//             isMulti={isMulti} // Important for multi-select functionality
//             styles={{
//               control: (provided: any) => ({
//                 ...provided,
//                 width: "100%",
//                 backgroundColor: "transparent",
//                 minHeight: "42px",
//                 maxHeight: "120px", // limit the height
//                 flexWrap: "wrap",
//                 overflowY: "auto",
//               }),
//               menu: (provided: any) => ({
//                 ...provided,
//                 width: "100%",
//                 // backgroundColor: "transparent",   // update
//               }),
//               menuList: (provided: any) => ({
//                 ...provided,
//                 paddingTop: 0,
//                 paddingBottom: 0,
//                 maxHeight: "150px", // Limit the total dropdown height
//               }),
//               multiValue: (provided: any) => ({
//                 ...provided,
//                 backgroundColor: badgeBackgroundColor, // Apply badge color here
//                 color: "white",
//               }),
//               multiValueLabel: (provided: any) => ({
//                 ...provided,
//                 color: "white",
//               }),
//               multiValueRemove: (provided: any) => ({
//                 ...provided,
//                 color: "white",
//                 ":hover": {
//                   backgroundColor: "#d32f2f",
//                 },
//               }),
//             }}
//             onMenuScrollToBottom={onMenuScrollToBottom}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RouteDropdown;

// New workign In Progess

import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

interface OptionType {
  id: string | number;
  label: string | number;
}

interface RouteDropdownProps {
  options: OptionType[];
  value?: string | number | null | (string | number)[]; // Updated to support both single and multi
  onChange: (value: string | number | (string | number)[]) => void;
  placeholder?: string;
  isDisabled?: boolean;
  DropdownHeading?: string;
  sideDropdownHeading?: string;
  isMulti?: boolean; // New prop for multi-select mode
  badgeBackgroundColor?: string;
  onInputChange?: (inputValue: string) => void;
  onMenuScrollToBottom?: () => void;
  asterisk?:boolean
}

const RouteDropdown: React.FC<RouteDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = "Select an option...",
  isDisabled = false,
  DropdownHeading = "",
  sideDropdownHeading = "",
  isMulti = false, // Default is false for single-select mode
  badgeBackgroundColor = "#43B9B2",
  onInputChange,
  onMenuScrollToBottom,
  asterisk=false
}) => {
  const formattedOptions = options?.map((option) => ({
    value: option.id.toString(),
    label: option.label,
  }));

  const selectedValue = isMulti
    ? formattedOptions.filter((option) =>
        Array.isArray(value)
          ? value.includes(option.value)
          : option.value === value?.toString()
      )
    : formattedOptions.find((option) => option.value == value?.toString());

  return (
    <div style={{ width: "100%",}}>
      {DropdownHeading && (
        <label
          style={{
            fontWeight: "500",
            marginBottom: "6px",
            display: "block",
            marginTop: "10px",
            whiteSpace: "nowrap",       // keep text in one line
            overflow: "hidden",         // hide overflow
            textOverflow: "ellipsis", 
          }}
        >
          {DropdownHeading}{asterisk &&(<span style={{color:"red"}}>*</span>)}

        </label>
      )}

      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        {sideDropdownHeading && (
          <p
            style={{
              display: "flex",
              alignItems: "center",
              color: "#2e8dd3",
              marginRight: "5px",
              fontWeight: "500",
              marginLeft: "5px",
              justifyContent: "center",
              width: "100%",
              marginTop: "10px",
            }}
          >
            {sideDropdownHeading}</p>
        )}

        <div style={{ width: "100%" }}>
          <Select
            options={formattedOptions}
            value={selectedValue || null}
            onChange={(selectedOption: any) => {
              if (isMulti) {
                const selectedValues = selectedOption.map(
                  (option: any) => option.value
                );
                onChange(selectedValues);
              } else {
                onChange(selectedOption?.value);
              }
            }}
            onInputChange={(inputValue) => {
              if (typeof onInputChange === "function") {
                onInputChange(inputValue);
              }
            }}
            placeholder={placeholder}
            isDisabled={isDisabled}
            isSearchable={true}
            isMulti={isMulti}
            styles={{
              control: (provided: any) => ({
                ...provided,
                width: "100%",
                backgroundColor: "transparent",
                minHeight: "42px",
                maxHeight: "120px",
                flexWrap: "wrap",
                overflowY: "auto",
              }),
              menu: (provided: any) => ({
                ...provided,
                width: "100%",
              }),
              menuList: (provided: any) => ({
                ...provided,
                paddingTop: 0,
                paddingBottom: 0,
                maxHeight: "150px",
              }),
              singleValue: (provided: any) => ({
                ...provided,
                paddingLeft: "12px", // ✅ This applies padding-left to selected value
              }),
              multiValue: (provided: any) => ({
                ...provided,
                backgroundColor: badgeBackgroundColor,
                color: "white",
              }),
              multiValueLabel: (provided: any) => ({
                ...provided,
                color: "white",
              }),
              multiValueRemove: (provided: any) => ({
                ...provided,
                color: "white",
                ":hover": {
                  backgroundColor: "#d32f2f",
                },
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RouteDropdown;
